import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {AppConfig} from '../AppConfig';
import {Observable} from 'rxjs';
import {  SolicitudGerente } from 'src/app/models/solicitudGerente';
import {map} from 'rxjs/operators';
import {Estado} from '../models/InmuebleSearch.model.response';


@Injectable({
  providedIn: 'root'
})
export class DirectorioContactosService {

  headers = new HttpHeaders({'Content-Type': 'application/json'});
  endpoint = '';

  constructor(private http: HttpClient, public appConfig: AppConfig) {
    this.endpoint = this.appConfig.getConfig('base_url');
  }

  getAllContactos(request: any, totalReg: number): Observable<any> {
    return this.http.post(`${this.endpoint}/bnt/inmuebles/gerentes/${totalReg}`, request, {headers: this.headers})
        .pipe(map((data: any) => {
          return data.respuesta;
        }))
  }

  getEstados(): Observable<Estado[]>{
    return this.http.post(`${this.endpoint}/bnt/inmuebles/getEstados`,null,{headers: this.headers})
        .pipe(map((data: any) => {
          return data.respuesta;
        }))
  }
  guardarNuevaSolicitud(directorioContacto: SolicitudGerente){
        return this.http.post(`${this.endpoint}/bnt/inmuebles/directorioGerenteSolicitud`,directorioContacto,{headers:this.headers});
      }
}
